/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pedometer 2': {
    width: 16,
    height: 16,
    viewBox: '0 0 63.26 68.56',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M17.51 55.44a7.75 7.75 0 0 0 7.28-8.23 20.52 20.52 0 0 0-1.71-7.28 22.13 22.13 0 0 1-1.54-8 41.3 41.3 0 0 1 .63-5.07 42 42 0 0 0 .63-7.1c-.11-6.08-1.36-10.84-3.51-14.16a10.18 10.18 0 0 0-8.7-5.1c-3.77.07-6.53 2.7-8.06 6a26.16 26.16 0 0 0-2 11.17 85 85 0 0 0 2.66 18.24c1.73 6.69 4.22 13.16 8.12 16.8M54.19 10.94c-3.4-.38-6.72 1.22-9.2 4.51s-4.18 8.17-4.9 14.55a46.63 46.63 0 0 0-.09 7.51 45.86 45.86 0 0 1 .12 5.39 24.33 24.33 0 0 1-2.33 8.28 22.83 22.83 0 0 0-2.43 7.52c-.59 5.25 2.83 8.91 6.43 9.32 3.16.35 6-1.43 8.41-4.14a39 39 0 0 0 6.1-10.44 94.16 94.16 0 0 0 6.23-23.51A28.93 28.93 0 0 0 61.62 18c-1.2-3.63-3.68-6.64-7.43-7.06z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/pedometer 2.js